/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = [".inprogressConsent[_ngcontent-%COMP%]{margin-top:110px}.inprogressConsent[_ngcontent-%COMP%]   h1[_ngcontent-%COMP%]{color:#eabf23;font-family:lato-bold;font-size:30px}.inprogressConsent[_ngcontent-%COMP%]   h3[_ngcontent-%COMP%]{font-family:Lato-Medium;color:#333;font-size:16px}.inprogressConsent[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]{font-family:Lato-Medium;color:#666;font-size:14px;line-height:normal}"];
export { styles as styles };

